"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiResult = void 0;
/**
 * API 처리 결과 코드
 */
var ApiResult;
(function (ApiResult) {
    /** 정상처리 */
    ApiResult["OK"] = "ok";
    /** 오류 */
    ApiResult["ERROR"] = "error";
    /** 오류 */
    ApiResult["NOT_LOGIN"] = "not-login";
})(ApiResult = exports.ApiResult || (exports.ApiResult = {}));
//# sourceMappingURL=api-wrapper.js.map